import React from 'react';
import './Education.css';

const Education = () => {
    return (
        <div id="academic">
            <div className="academic section-container">
                <div className="academic-header">
                    <h1 className="section-title">Academic <span>Career</span></h1>
                </div>
                <div className="academic-items row d-flex justify-content-between">
                    <div className="col-12 col-md-6">
                        <i className="fas fa-university"></i>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="border-start ps-3 border-3 border-dark academic-item">
                            <h1 className="academic-title">S<span style={{ 'color': 'rgb(121, 192, 162)' }}>S</span>C</h1>
                            <h4>Natural Gas Fertilizer Factory School</h4>
                            <h4>Fenchuganj, Sylhet</h4>
                            <h4>2004-2014</h4>
                        </div>
                        <div className="border-start ps-3 border-3 border-dark academic-item">
                            <h1 className="academic-title">H<span style={{ 'color': 'rgb(121, 192, 162)' }}>S</span>C</h1>
                            <h4>Scholarshome College</h4>
                            <h4>Shahi Eidgah, Sylhet</h4>
                            <h4>2014-2016</h4>
                        </div>
                        <div className="border-start ps-3 border-3 border-dark academic-item">
                            <h1 className="academic-title">Gradu<span style={{ 'color': 'rgb(121, 192, 162)' }}>a</span>tion</h1>
                            <h4>B.Sc in Computer Science and Engineering</h4>
                            <h4>Daffodil International University</h4>
                            <h4>Dhanmondi, Dhaka</h4>
                            <h4>2018-2022</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Education;